import { actionGenerator, IReduxAction } from '../../redux/actionGenerator';

export const SAVE_DRAFT_START = 'DRAFT :: SAVE_START';

export type TSaveDraftStartAction = IReduxAction<typeof SAVE_DRAFT_START>;

export const saveDraftStart = actionGenerator<typeof SAVE_DRAFT_START>(SAVE_DRAFT_START);
